import { Component, Input, OnInit } from '@angular/core';
import { ExportGrundstueckbeschreibung } from '../../../../../core/batch-auftrag-api';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { AtLeastOneValidatorDirective } from '../../../shared/validators/at-least-one-validator.directive';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-select-grundstueckbeschreibung',
  templateUrl: './select-grundstueckbeschreibung.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [
    AtLeastOneValidatorDirective,
    FormsModule,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class SelectGrundstueckbeschreibungComponent implements OnInit {
  @Input()
  model: ExportGrundstueckbeschreibung;

  @Input()
  disabled: boolean;

  constructor() {}

  ngOnInit() {}
}
